import React from 'react'

import TableShared from '../TableShared'
import { useTranslation } from 'react-i18next'
import { useStateContext } from '../../context/ContextProvider'

const SummaryByItem = ({ items }) => {

    const { t } = useTranslation()

    const columns = [

        {
            field: 'item_no',
            headerName: t('item_no'),
            flex: 1,
            minWidth: 140
        },
        {
            field: 'quantity_collected',
            headerName: t('quantity_collected'),
            flex: 1,
            minWidth: 140
        },
        {
            field: 'total_value',
            headerName: t('total_value'),
            flex: 1,
            renderCell: (params) => <Total params={params} />,
            minWidth: 140
        },
        {
            field: 'item_per',
            headerName: t('item_per'),
            flex: 1,
            minWidth: 140
        }
    ]

    return (
        <div className=''>
            <div className='p-5 border-b'>
                <div className='flexjustify-start items-center'>
                    <p style={{ fontWeight: 600, fontSize: '16px' }}>{t('summary_by_item')}</p>
                </div>
            </div>
            <div className='pt-3'>
                <TableShared breakHeaders={true} items={items} columns={columns} rowsPerPageOptions={[5, 10]} border='none'/>
            </div>
        </div>
    )
}

export default SummaryByItem

const Total = (params) => {
    const { currencySymbol } = useStateContext()

    return (
        <>{currencySymbol}{params.params.row.total_value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</>
    )
}
